import { render, staticRenderFns } from "./VrschoolTest1View.vue?vue&type=template&id=ffe8725a&scoped=true&"
import script from "./VrschoolTest1View.vue?vue&type=script&lang=js&"
export * from "./VrschoolTest1View.vue?vue&type=script&lang=js&"
import style0 from "./VrschoolTest1View.vue?vue&type=style&index=0&id=ffe8725a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe8725a",
  null
  
)

export default component.exports